import { useEffect } from 'react';

/**
 * Registers a global Cmd (⌘) / Ctrl + `key` shortcut on `window`. `key`
 * is matched case-insensitively. Mount once, in the app shell.
 */
export function useMetaKeyShortcut(key: string, onTrigger: () => void): void {
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent): void {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === key) {
        e.preventDefault();
        onTrigger();
      }
    }
    globalThis.addEventListener('keydown', onKeyDown);
    return () => {
      globalThis.removeEventListener('keydown', onKeyDown);
    };
  }, [key, onTrigger]);
}
